import ContactActions from 'bukku/redux/Contact/actions';
import TransactionActions from 'bukku/redux/Transaction/actions';
import { shallowEqual, useSelector } from "react-redux";
import { FileListModule } from '../../../enum/FileListModule';

const {
    removeFile: removeTransactionFile,
    setFiles: setTransactionFiles,
    addFile: addTransactionFile,
} = TransactionActions;
const {
    removeFile: removeContactFile,
    setFiles: setContactFiles,
    addFile: addContactFile,
} = ContactActions;

/**
 * Hook to configure file list based on module type.
 * @param {FileListModule} moduleType - The type of the module - FileListModule.TRANSACTION or FileListModule.CONTACT.
 * @throws Will throw an error if the module type is invalid.
 * @returns {{files:import('../components/FilesList/useLightboxHandler').File[], removeFile: function|null, setFiles: function|null, addFile: function|null}}
 *  The file list configuration object.
 * - files: The list of files.
 * - removeFile: The function to remove a file. - only used in panelOther's File List (delete btn).
 * - setFiles: The function to set files. - only used in panelOther's File Manager (update file list)
 * - addFile: The function to add a file. - only used in panelOther's Uploads.
 */
export const useFilesListConfig = moduleType => {
    const transactionFiles = useSelector(state => state.Transaction.files, shallowEqual);
    const contactFiles = useSelector(state => state.Contact.files, shallowEqual);
    const fileManagerFile = useSelector(state => state.File.file, shallowEqual);

    if (moduleType && FileListModule[moduleType] === undefined)
        throw new Error('Invalid FileListModule type', moduleType);

    // to normalise file manager's preview file into same structure as contacts and transaction files
    const normalizeFileManagerFile = file => ({
        id: null,
        created_at: file.created_at,
        file_id: file.id,
        is_shared: false,
        file: {
            id: file.id,
            filename: file.filename,
            mime_type: file.mime_type,
            size: file.size,
            created_at: file.created_at,
            updated_at: file.updated_at,
            url: file.url,
        },
    });

    const fileListConfig = {
        [FileListModule.TRANSACTION]: {
            files: transactionFiles,
            removeFile: removeTransactionFile,
            setFiles: setTransactionFiles,
            // setFile: setTransactionFile,
            addFile: addTransactionFile,
        },
        [FileListModule.CONTACT]: {
            files: contactFiles,
            removeFile: removeContactFile,
            setFiles: setContactFiles,
            // setFile: setContactFile,
            addFile: addContactFile,
        },
        [FileListModule.FILE_MANAGER]: {
            files: [normalizeFileManagerFile(fileManagerFile)],
            removeFile: null,
            setFiles: null,
            addFile: null,
        },
    };

    const { files, removeFile, setFiles, addFile } = fileListConfig[moduleType];

    return {
        files,
        removeFile,
        setFiles,
        // setFile,
        addFile,
    };
};
